import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Entity, IRelatedEntity, RelatedEntity } from '@app/core/model/entities/entity';
import { Expose } from 'class-transformer';

export class Meeting extends Entity {
  public objectType = EntityTypeEnum.MEETING;
  public identifier: number;
  public organizationId: string;

  @Expose()
  public toString(): string {
    return this.computedProperties?.['displayName'] ?? `${this.identifier.toString()} - ${this.name}`;
  }

  /**
   * Transforms this Meeting to a RelatedMeeting.
   */
  public toRelatedMeeting(): RelatedMeeting {
    return new RelatedMeeting({
      id: this.id,
      name: this.name,
      identifier: this.identifier,
      displayName: this.computedProperties?.['displayName']
    });
  }
}

export interface MeetingInput {
  name?: string;
  properties?: Record<string, any>;
}

export type IRelatedMeeting = IRelatedEntity;

export class RelatedMeeting extends RelatedEntity implements IRelatedMeeting {
  constructor(relatedMeeting: IRelatedMeeting) {
    super(relatedMeeting);
  }
}
